import geLogo from "@assets/general-election/ge-logo-v1.svg";
import Ad from "@components/Advertisement/Ad";
import { KeywordButtonType } from "@components/Button/utils/types";
import Container from "@components/Container/Container";
import SeoFooter from "@components/Footer/SeoFooter/SeoFooter";
import { GADataProps } from "@components/GAData/GAData";
import Header from "@components/Header/Header";
import KeywordFilter from "@features/mybt/components/KeywordFilter";
import { KeywordType } from "@features/mybt/components/KeywordFilter/utils/types";
import PulseEntry from "@features/pulse/components/PulseEntry/PulseEntry";
import { useInjectClientData } from "@hooks/useInjectClientData";
import SectionsTemplate from "@routes/SingaporeGe/2025/components/SectionsTemplate";
import {
  defaultConfig,
  GE2025_PAGE_QUERY,
} from "@routes/SingaporeGe/2025/utils/constants";
import { SingaporeGe2025Data } from "@routes/SingaporeGe/utils/types";

/**
 * SingaporeGe2025Page component to display the Singapore GE 2025 page.
 * Figma: https://www.figma.com/design/EUTUYjBn7HHbsLRjqK4t5h/GE-2025--WEB---APP-?node-id=11563-25920&t=4NXCtXdS4g1R5hiL-4
 */
const SingaporeGe2025Page = ({
  highlights,
  relatedStories,
  config,
  entity,
  seoFooterData,
  gaProps,
}: SingaporeGe2025Data & { gaProps: GADataProps }): React.ReactElement => {
  useInjectClientData({ gaProps });

  const configData = config?.configObj || defaultConfig;
  const parentCategory = GE2025_PAGE_QUERY.substring(1);

  return (
    <div className="w-full" data-testid="singapore-ge-2025-page-component">
      <Ad
        adType="lb1"
        className="flex min-h-[calc(50px+0.50rem)] flex-col items-center justify-center border-b border-gray-175 bg-gray-125 py-1 text-center md:py-3 lg:min-h-[calc(250px+1.5rem)]"
      />

      <Header parentCategory={parentCategory} />

      <PulseEntry />

      <Container rootClassName="pt-6">
        <div className="mb-3 flex items-center justify-between border-b border-gray-850 pb-3">
          <img
            src={geLogo}
            width={150}
            height={60}
            alt="Singapore GE 2025"
            className="w-[130px] lg:w-[150px]"
          />

          <KeywordFilter
            keywordButtonType={KeywordButtonType.version2}
            tag={entity.tag}
            disableTooltip
            className="inline-block"
            keywordType={KeywordType.noTag}
          />
        </div>

        <>
          {configData.map((config, index) => {
            return (
              <SectionsTemplate
                key={`${config.type}-${index}`}
                configData={config}
                highlights={highlights}
                relatedStories={relatedStories}
                index={index}
                entity={entity}
              />
            );
          })}
        </>
      </Container>

      <SeoFooter data={seoFooterData} />

      <Ad adType="catfish" />
      <Ad adType="prestitial" />
    </div>
  );
};

export default SingaporeGe2025Page;
